<div class="banner1">
<div class="banner">
   <div class="carousel-caption d-flex flex-column align-items-center justify-content-center">

                        <div class="p-3" style="max-width: 900px;">
                            <img src="/assets/img/whiteicon.png " class = "logo">
                            <h5  >Robo-Advisor</h5>
                            <h1 class="text-white text-uppercase mb-3 animated slideInDown"> Bienvenue AU ROBO ADVISOR</h1>
                            <h4 class = "hidemob" >Profitez des recommendations journalières de notre conseiller intelligent</h4>
                            <h4 class = "hidepc" >Votre meilleur conseiler de bourse </h4>
                            <a routerLink="/login" class="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft"> Se Connecter</a>
                            <a routerLink="/signup"class="btn btn-outline-light py-md-3 px-md-5 animated slideInRight">S'inscrire</a>
                        </div>
   </div>
</div>
</div>